import React, {useEffect, useMemo, useState} from "react";

import styled from "styled-components";
import InfiniteScroll from "react-infinite-scroll-component";
import NewsPost from "./NewsPost";
import {useIntl} from "react-intl";
import m from "../../../definedMessages";

import { List, Loader, Placeholder } from "rsuite";

const {Paragraph} = Placeholder;


export default (
    {
        data,
        count,
        inited,
        lang,
        getNewsDialer,
    }
) => {
    const {formatMessage} = useIntl();
    const [perPage, setPerPage]  = useState(10);

    const dataUpdated = useMemo(() => {

        return data.map(item => {
            return {
                id: item.id,
                read: item.read,
                text: item.text,
                text_arabic: item.text_arabic,
                date: item.created_at,
            }
        });
    }, [data]);

    useEffect(() => {
        getNewsDialer(1, perPage);
    }, [perPage]);


    if (!inited && dataUpdated.length === 0) {
        return <div style={{position: "relative"}}>
            <Paragraph rows={16}/>
            <Loader center content="loading" />
        </div>
    }


    const handleFetchNextData = () => {
        setPerPage(perPage + 10);
    };


    return (
        <InfiniteScroll
            dataLength={dataUpdated.length}
            next={handleFetchNextData}
            hasMore={dataUpdated.length < count}
            loader={<StyledLoader><Loader size={'md'} content={formatMessage(m.loadingData)} /></StyledLoader>}
            endMessage={<StyledLoader>{formatMessage(m.allDataIsCompletelyFetched)}</StyledLoader>}
        >
            <StyledList>
                {dataUpdated.map((item, index) => {
                    return (
                        <List.Item key={index}>
                            <NewsPost
                                lang={lang}
                                {...{
                                    item,
                                }}
                            />
                        </List.Item>
                    )
                })}
            </StyledList>
        </InfiniteScroll>
    )
};


const StyledList = styled(List)`
    display: flex;
    flex-wrap: wrap;

    .rs-list-item {
        padding: 30px 20px;
        width: 100%;
    }
`;


const StyledLoader = styled.div`
    padding: 30px;
    text-align: center;
`;